import FreshChat from './FreshChat.vue';
import { VueI18nHelper } from '../../helpers/VueI18nHelper';
import config from '../../../config';

VueI18nHelper.initVueI18NextForPage(FreshChat, `.freshchat-vue`, [config.locize.webshopWordpress.namespaces.MISC]);
